import React from "react";
import { cn } from "../lib/helpers";
import Container from "./container";

import * as styles from "../styles/components/fc-stats.module.css";

interface StatItem {
  _key?: string;
  number?: string;
  text?: string;
}

interface StatsProps {
  title?: string;
  stats?: StatItem[];
}

const Stats: React.FC<StatsProps> = ({
  title,
  stats,
}) => {
  if (!stats || stats.length === 0) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Container>
        {title && (
          <h2 className={cn("h4", styles.title)}>{title}</h2>
        )}

        <div className={cn("grid", styles.grid)}>
          {stats.map(({ _key, number, text }) => (
            <div className={cn("col-sm-6 col-lg-3", styles.item)} key={_key}>
              <div className={styles.inner}>
                {number && (
                  <div className={cn("h2", styles.number)}>{number}</div>
                )}
                {text && (
                  <div className={cn("body-small", styles.text)}>{text}</div>
                )}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default Stats;
